export const basicPoiFields = [
    {
        index: 0,
        name: 'id',
        alias: 'Identifiant Unique',
        type: 'string',
        native: true,
        visible: true,
    },
    {
        index: 1,
        name: 'name',
        alias: 'Nom',
        type: 'string',
        visible: true,
        native: true,
    },
    {
        index: 2,
        name: 'description',
        alias: 'Description',
        type: 'string',
        visible: true,
        native: true,
    },
    {
        index: 3,
        name: "address",
        alias: 'Adresse',
        type: 'string',
        visible: true,
        native: true,
    },
    {
        index: 4,
        name: "postal_code",
        alias: 'Code postal',
        type: 'string',
        visible: true,
        native: true,
    },
    {
        index: 5,
        name: 'city',
        alias: 'Ville',
        type: 'string',
        visible: true,
        native: true,
    },
    {
        index: 6,
        name: 'latitude',
        alias: 'Latitude',
        type: 'number',
        visible: false,
        native: true,
    },
    {
        index: 7,
        name: 'longitude',
        alias: 'Longitude',
        type: 'number',
        visible: false,
        native: true,
    },
    {
        index: 8,
        name: 'geounit_code',
        alias: 'Code unité géographique',
        type: 'string',
        visible: false,
        native: true,
    },
    {
        index: 9,
        name: 'geocodere_accuracy',
        alias: 'Précision du géocodage',
        type: 'string',
        visible: false,
        native: true,
    },
    {
        index: 10,
        name: 'open_date',
        alias: 'Date d\'ouverture',
        type: 'date',
        visible: true,
        native: true,
    }
];
//# sourceMappingURL=Field.js.map